<template>
  <transition name="toast-fade">
    <div :class="type + ' ' + (toastState.small ? 'small' : '')" class="global-toast" v-if="toastState.visible">
      {{ toastState.message }}
    </div>
  </transition>
</template>

<script setup>
import { toastService } from '@/utils/toastService'
import { isMobile } from '@/utils'

const type = isMobile ? 'mobile' : 'pc'
// 直接使用toastService中的状态
const toastState = toastService.getState()
</script>

<style lang="less" scoped>
.global-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 8px 10px;
  border-radius: 4px;
  z-index: 10000;
  max-width: 80vw;
  text-align: center;
  font-size: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s;
}

.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
}
</style>
<!-- <style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>  -->